import { Subject } from 'rxjs/Subject';
import { of } from 'rxjs/observable/of';
import { _throw } from 'rxjs/observable/throw';

export class TokenLoader {
  _tokenService
  _urlTokenParser

  constructor(tokenService, urlTokenParser) {
    this._tokenService = tokenService;
    this._urlTokenParser = urlTokenParser;
  }

  loadToken() {
    const token = this._urlTokenParser.parseToken() || this._tokenService.getToken();
    if(!token) {
      return _throw('Token Load Failed');
    }
    
    return of(token);
  }
}